
$(document).ready(function () {
	if ($(".js-genre-filter").length) {
		$(".js-genre-filter").on("change", function() {
			$(".js-genre-filter-form").submit();
		});
	}
})